import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { PButtonPure } from "@porsche-design-system/components-react"
import { useCallback, useEffect, useMemo } from "react"
import { trackEvent } from "src/components/adobeAnalytics"
import { useModal } from "src/context/modal/useModal"
import { useLocalStorage } from "src/hooks"
import { WhatsNewModal } from "src/modals/whatsNewModal/WhatsNewModal"
import { supportedLanguages, whatsNewMessages } from "src/modals/whatsNewModal/whatsNew.messages"
import type { SupportedLanguage } from "src/modals/whatsNewModal/whatsNew.messages"

const trackWhatsNewEvent = (action: string) => {
	trackEvent({
		action,
		category: "whats_new_modal",
	})
}

export const WhatsNewContainer = () => {
	const { locale } = useDealerContext()
	const language = useMemo<SupportedLanguage>(() => {
		const [lang] = locale.split("-") as [SupportedLanguage]
		return supportedLanguages.includes(lang) ? lang : "en"
	}, [locale])

	// open modal automatically until it is dismissed, upon new contents, just change the key
	const [isWhatsNewSeen, setHasSeenWhatsNew] = useLocalStorage("hasSeenWhatsNewNotificationCenter", "false")
	const hasSeenWhatsNew = isWhatsNewSeen === "true"

	const onDismiss = useCallback(() => {
		setHasSeenWhatsNew("true")
		trackWhatsNewEvent("close_whats_new")
	}, [setHasSeenWhatsNew])

	const showWhatsNewModal = useModal(WhatsNewModal)
	const showModal = useCallback(
		(trigger: "automatically" | "manually") => {
			showWhatsNewModal({ language, onDismiss })
			trackWhatsNewEvent(`open_whats_new_${trigger}`)
		},
		[showWhatsNewModal, language, onDismiss],
	)

	const onWhatsNewClick = useCallback(() => {
		showModal("manually")
	}, [showModal])

	useEffect(() => {
		if (!hasSeenWhatsNew) {
			showModal("automatically")
		}
	}, [hasSeenWhatsNew, showModal])

	return (
		<PButtonPure icon="news" onClick={onWhatsNewClick}>
			{whatsNewMessages[language].buttonLabel}
		</PButtonPure>
	)
}
